var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { observable, computed, reaction, action } from 'mobx';
import isEmail from 'validator/es/lib/isEmail';
import isMobilePhone from 'validator/es/lib/isMobilePhone';
import isNumeric from 'validator/es/lib/isNumeric';
import GravityChoiceData from './GravityChoiceData';
let GravityFieldData = (() => {
    var _a, _GravityFieldData_valueProvider_accessor_storage, _GravityFieldData_inputValue_accessor_storage, _GravityFieldData_choiceData_accessor_storage, _GravityFieldData_visible_accessor_storage, _GravityFieldData_hasBeenBlurred_accessor_storage, _GravityFieldData_isDirty_accessor_storage;
    var _b;
    let _instanceExtraInitializers = [];
    let _valueProvider_decorators;
    let _valueProvider_initializers = [];
    let _valueProvider_extraInitializers = [];
    let _inputValue_decorators;
    let _inputValue_initializers = [];
    let _inputValue_extraInitializers = [];
    let _choiceData_decorators;
    let _choiceData_initializers = [];
    let _choiceData_extraInitializers = [];
    let _visible_decorators;
    let _visible_initializers = [];
    let _visible_extraInitializers = [];
    let _hasBeenBlurred_decorators;
    let _hasBeenBlurred_initializers = [];
    let _hasBeenBlurred_extraInitializers = [];
    let _isDirty_decorators;
    let _isDirty_initializers = [];
    let _isDirty_extraInitializers = [];
    let _get_choices_decorators;
    let _get_options_decorators;
    let _get_selected_decorators;
    let _get_isVisible_decorators;
    let _setValue_decorators;
    let _get_isTouched_decorators;
    let _get_isMissing_decorators;
    let _get_hasError_decorators;
    let _get_isValid_decorators;
    return _a = class GravityFieldData {
            get valueProvider() { return __classPrivateFieldGet(this, _GravityFieldData_valueProvider_accessor_storage, "f"); }
            set valueProvider(value) { __classPrivateFieldSet(this, _GravityFieldData_valueProvider_accessor_storage, value, "f"); }
            get inputValue() { return __classPrivateFieldGet(this, _GravityFieldData_inputValue_accessor_storage, "f"); }
            set inputValue(value) { __classPrivateFieldSet(this, _GravityFieldData_inputValue_accessor_storage, value, "f"); }
            get choiceData() { return __classPrivateFieldGet(this, _GravityFieldData_choiceData_accessor_storage, "f"); }
            set choiceData(value) { __classPrivateFieldSet(this, _GravityFieldData_choiceData_accessor_storage, value, "f"); }
            get visible() { return __classPrivateFieldGet(this, _GravityFieldData_visible_accessor_storage, "f"); }
            set visible(value) { __classPrivateFieldSet(this, _GravityFieldData_visible_accessor_storage, value, "f"); }
            get hasBeenBlurred() { return __classPrivateFieldGet(this, _GravityFieldData_hasBeenBlurred_accessor_storage, "f"); }
            set hasBeenBlurred(value) { __classPrivateFieldSet(this, _GravityFieldData_hasBeenBlurred_accessor_storage, value, "f"); }
            get isDirty() { return __classPrivateFieldGet(this, _GravityFieldData_isDirty_accessor_storage, "f"); }
            set isDirty(value) { __classPrivateFieldSet(this, _GravityFieldData_isDirty_accessor_storage, value, "f"); }
            constructor(definition, valueProvider) {
                var _b;
                Object.defineProperty(this, "id", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: __runInitializers(this, _instanceExtraInitializers)
                });
                Object.defineProperty(this, "type", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "label", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "maxLength", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "placeholder", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "className", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "isDisabled", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "isRequired", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "isReadOnly", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "isStatic", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "defaultValue", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "description", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "content", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "conditionalLogic", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "dependentFieldIds", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "technicalParameter", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "limitDateRange", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "minDate", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "maxDate", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "inputName", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "labelHidden", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "visibility", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "enableAutocomplete", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "autocompleteAttributes", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "isChoiceField", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "isRadioField", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "onSubmit", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "selectedOption", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                _GravityFieldData_valueProvider_accessor_storage.set(this, __runInitializers(this, _valueProvider_initializers, void 0));
                _GravityFieldData_inputValue_accessor_storage.set(this, (__runInitializers(this, _valueProvider_extraInitializers), __runInitializers(this, _inputValue_initializers, void 0)));
                _GravityFieldData_choiceData_accessor_storage.set(this, (__runInitializers(this, _inputValue_extraInitializers), __runInitializers(this, _choiceData_initializers, [])));
                _GravityFieldData_visible_accessor_storage.set(this, (__runInitializers(this, _choiceData_extraInitializers), __runInitializers(this, _visible_initializers, false)));
                _GravityFieldData_hasBeenBlurred_accessor_storage.set(this, (__runInitializers(this, _visible_extraInitializers), __runInitializers(this, _hasBeenBlurred_initializers, false)));
                _GravityFieldData_isDirty_accessor_storage.set(this, (__runInitializers(this, _hasBeenBlurred_extraInitializers), __runInitializers(this, _isDirty_initializers, false)));
                Object.defineProperty(this, "doOnSubmit", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: (__runInitializers(this, _isDirty_extraInitializers), () => {
                        this.inputValue = this.getValue();
                        this.hasBeenBlurred = true;
                    })
                });
                Object.defineProperty(this, "trackChoice", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: (trackable) => {
                        reaction(() => trackable.isTouched && trackable.isSelected, (selected) => {
                            if (selected) {
                                this.choiceData.filter((choice) => choice !== trackable).forEach((choice) => (choice.isSelected = false));
                            }
                        });
                    }
                });
                Object.defineProperty(this, "getValue", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: () => {
                        var _b;
                        if (this.isChoiceField) {
                            return null;
                        }
                        if ((this.hasBeenBlurred || this.isDirty) && this.isVisible) {
                            return this.inputValue;
                        }
                        return ((_b = this.valueProvider) === null || _b === void 0 ? void 0 : _b.getValue(this.id)) || this.defaultValue;
                    }
                });
                this.type = definition.type;
                this.id = definition.id;
                this.label = definition.label;
                this.maxLength = definition.maxLength;
                this.placeholder = definition.placeholder;
                this.className = definition.cssClass;
                this.isDisabled = definition.displayOnly || definition.disabled;
                this.isReadOnly = definition.readOnlyField;
                this.isStatic = definition.staticField;
                this.isRequired = definition.required;
                this.defaultValue = definition.defaultValue;
                this.description = definition.description;
                this.content = definition.content;
                this.conditionalLogic = definition.conditionalLogic;
                this.dependentFieldIds = definition.dependentFieldIds;
                this.technicalParameter = definition.technicalParameter;
                this.limitDateRange = definition.limitDateRange;
                this.minDate = definition.minDate;
                this.maxDate = definition.maxDate;
                this.inputName = definition.inputName;
                this.labelHidden = definition.labelPlacement === 'hidden_label';
                this.visibility = definition.visibility;
                this.enableAutocomplete = definition.enableAutocomplete;
                this.autocompleteAttributes = definition.autocompleteAttributes;
                this.isChoiceField = ['select', 'multiselect', 'radio', 'checkbox', 'consent'].includes(this.type);
                this.isRadioField = ['radio', 'select'].includes(this.type);
                this.valueProvider = valueProvider;
                this.onSubmit = this.doOnSubmit;
                if (this.isChoiceField) {
                    const choiceProvider = valueProvider ? valueProvider.getChoiceProvider(definition.id) : null;
                    this.choiceData = definition.choices.map((choice, index) => {
                        const choiceData = new GravityChoiceData(choice, index + 1, choiceProvider);
                        if (this.isRadioField) {
                            this.trackChoice(choiceData);
                        }
                        return choiceData;
                    });
                }
                else {
                    this.inputValue = (_b = this.valueProvider) === null || _b === void 0 ? void 0 : _b.getValue(this.id);
                }
            }
            get choices() {
                return this.choiceData.slice();
            }
            get options() {
                return this.choiceData.map((choice) => choice.option);
            }
            get selected() {
                const choices = this.choiceData.filter((choice) => choice.isSelected);
                switch (this.type) {
                    case 'select':
                        return choices.length > 0 ? choices[0].option : null;
                    case 'multiselect':
                        return choices.map((choice) => choice.option);
                    default:
                        return null;
                }
            }
            set selected(options) {
                this.choiceData.forEach((choice) => {
                    choice.isSelected = Array.isArray(options) ? options.includes(choice.option) : choice.option === options;
                });
            }
            set isVisible(visible) {
                this.visible = visible;
            }
            get isVisible() {
                return this.visible;
            }
            setValue(value) {
                if (value != null && !this.isChoiceField) {
                    this.inputValue = value;
                    this.isDirty = true;
                }
            }
            get isTouched() {
                return this.hasBeenBlurred;
            }
            get isMissing() {
                if (!this.isRequired || !this.isVisible) {
                    return false;
                }
                if (this.isChoiceField) {
                    return !this.choiceData.some((choice) => choice.isSelected);
                }
                return !this.getValue();
            }
            get hasError() {
                const value = this.getValue();
                switch (this.type) {
                    case 'number':
                        return !!value && !isNumeric(value);
                    case 'phone':
                        return !!value && !isMobilePhone(value, 'any');
                    case 'email':
                        return !!value && !isEmail(value);
                    default:
                        return false;
                }
            }
            get isValid() {
                return !this.isMissing && !this.hasError;
            }
        },
        _GravityFieldData_valueProvider_accessor_storage = new WeakMap(),
        _GravityFieldData_inputValue_accessor_storage = new WeakMap(),
        _GravityFieldData_choiceData_accessor_storage = new WeakMap(),
        _GravityFieldData_visible_accessor_storage = new WeakMap(),
        _GravityFieldData_hasBeenBlurred_accessor_storage = new WeakMap(),
        _GravityFieldData_isDirty_accessor_storage = new WeakMap(),
        (() => {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _valueProvider_decorators = [observable];
            _inputValue_decorators = [observable];
            _choiceData_decorators = [observable];
            _visible_decorators = [observable];
            _hasBeenBlurred_decorators = [observable];
            _isDirty_decorators = [observable];
            _get_choices_decorators = [computed];
            _get_options_decorators = [computed];
            _get_selected_decorators = [computed];
            _get_isVisible_decorators = [computed];
            _setValue_decorators = [(_b = action).bound.bind(_b)];
            _get_isTouched_decorators = [computed];
            _get_isMissing_decorators = [computed];
            _get_hasError_decorators = [computed];
            _get_isValid_decorators = [computed];
            __esDecorate(_a, null, _valueProvider_decorators, { kind: "accessor", name: "valueProvider", static: false, private: false, access: { has: obj => "valueProvider" in obj, get: obj => obj.valueProvider, set: (obj, value) => { obj.valueProvider = value; } }, metadata: _metadata }, _valueProvider_initializers, _valueProvider_extraInitializers);
            __esDecorate(_a, null, _inputValue_decorators, { kind: "accessor", name: "inputValue", static: false, private: false, access: { has: obj => "inputValue" in obj, get: obj => obj.inputValue, set: (obj, value) => { obj.inputValue = value; } }, metadata: _metadata }, _inputValue_initializers, _inputValue_extraInitializers);
            __esDecorate(_a, null, _choiceData_decorators, { kind: "accessor", name: "choiceData", static: false, private: false, access: { has: obj => "choiceData" in obj, get: obj => obj.choiceData, set: (obj, value) => { obj.choiceData = value; } }, metadata: _metadata }, _choiceData_initializers, _choiceData_extraInitializers);
            __esDecorate(_a, null, _visible_decorators, { kind: "accessor", name: "visible", static: false, private: false, access: { has: obj => "visible" in obj, get: obj => obj.visible, set: (obj, value) => { obj.visible = value; } }, metadata: _metadata }, _visible_initializers, _visible_extraInitializers);
            __esDecorate(_a, null, _hasBeenBlurred_decorators, { kind: "accessor", name: "hasBeenBlurred", static: false, private: false, access: { has: obj => "hasBeenBlurred" in obj, get: obj => obj.hasBeenBlurred, set: (obj, value) => { obj.hasBeenBlurred = value; } }, metadata: _metadata }, _hasBeenBlurred_initializers, _hasBeenBlurred_extraInitializers);
            __esDecorate(_a, null, _isDirty_decorators, { kind: "accessor", name: "isDirty", static: false, private: false, access: { has: obj => "isDirty" in obj, get: obj => obj.isDirty, set: (obj, value) => { obj.isDirty = value; } }, metadata: _metadata }, _isDirty_initializers, _isDirty_extraInitializers);
            __esDecorate(_a, null, _get_choices_decorators, { kind: "getter", name: "choices", static: false, private: false, access: { has: obj => "choices" in obj, get: obj => obj.choices }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_options_decorators, { kind: "getter", name: "options", static: false, private: false, access: { has: obj => "options" in obj, get: obj => obj.options }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_selected_decorators, { kind: "getter", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_isVisible_decorators, { kind: "getter", name: "isVisible", static: false, private: false, access: { has: obj => "isVisible" in obj, get: obj => obj.isVisible }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _setValue_decorators, { kind: "method", name: "setValue", static: false, private: false, access: { has: obj => "setValue" in obj, get: obj => obj.setValue }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_isTouched_decorators, { kind: "getter", name: "isTouched", static: false, private: false, access: { has: obj => "isTouched" in obj, get: obj => obj.isTouched }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_isMissing_decorators, { kind: "getter", name: "isMissing", static: false, private: false, access: { has: obj => "isMissing" in obj, get: obj => obj.isMissing }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_hasError_decorators, { kind: "getter", name: "hasError", static: false, private: false, access: { has: obj => "hasError" in obj, get: obj => obj.hasError }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_isValid_decorators, { kind: "getter", name: "isValid", static: false, private: false, access: { has: obj => "isValid" in obj, get: obj => obj.isValid }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { GravityFieldData };
export default GravityFieldData;
//# sourceMappingURL=GravityFieldData.js.map